import {Button, Col, Row, Space} from "antd";
import {useNavigate} from "react-router-dom";
import {StyledServiceButtonWrapper} from "../../../../styles/onboarding/onboarding";
import {useGetProductContext} from "../context/get-product";
import {FormWrapper} from "../../../../components/form-wrapper";
import {useDeleteProductHook} from "../hooks/delete-product";
import {OfferingDeleteButton} from "../../../../components/offering-form/general/delete-button";
import {EditProductContentPanel} from "./content-panel";

export function EditProductContentUpload() {
  const {
    state: {productData},
  } = useGetProductContext();
  const {deleteProduct} = useDeleteProductHook(productData.product.id);
  const navigate = useNavigate();

  function handleBack() {
    navigate("/products");
  }

  return (
    <FormWrapper>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <EditProductContentPanel productId={productData.product.id} />

        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                className="secondary-btn"
                onClick={handleBack}
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                htmlType="button"
                onClick={handleBack}
                size="small"
              >
                Update product
              </Button>
              <OfferingDeleteButton
                cancelText="Exit"
                content="Are you sure you want to delete this product? This action cannot be undone."
                okText="Delete product"
                onOk={deleteProduct}
                title="Confirm product deletion"
              />
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </FormWrapper>
  );
}
